import React from 'react';
import {Link} from 'react-router-dom'

class Navbar extends React.Component{

    loginClick = () =>{
        this.props.updateModal(true);
    }

    logoutClick = () => {
        this.props.updateLogin(false);
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('ivnj');
        localStorage.removeItem('reRen');
        window.location.href = '/'
    }

    render(){
        return(
            <nav className="navbar">
                <Link to="/" >
                    <img src="/images/bt-logo.webp" alt="logo" className="navbar__logo" />
                </Link>
                
                <div className="navbar__login" >
                    <a href="https://businesstoys.in/blog" 
                        className="tablet-off" 
                        target="_blank" 
                        rel="noreferrer" >Blog</a>
                    <a href="https://businesstoys.in/webinars/" 
                        target="_blank" 
                        rel="noreferrer"
                        className="tablet-off" 
                        >Webinars</a>
                    {
                        !this.props.isLoggedIn &&
                        <div className="navbar__login--down">
                            <p> Login/Register <i className="fas fa-caret-down"></i>  </p>
                            <div className="navbar__login--down--drop" >
                                <span className="navbar__login--down--drop--ele" onClick={this.loginClick} >Login</span>
                                <Link to="/register" className="navbar__login--down--drop--ele" >Register</Link>
                            </div>
                        </div>
                    }
                    {
                        this.props.isLoggedIn && 
                        <div className="navbar__login--user" onClick={this.logoutClick} >
                           <p>
                                Logout <i className="fas fa-sign-out-alt"></i>
                           </p>
                        </div>
                    }
                </div>
            </nav>
        )
    }
};

export default Navbar;